import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { dialogs, i18next, site } from '@yola/ws-sdk';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import saveSite from 'src/js/modules/saving/helpers/save-site';
import FolderSettingsDialog from '../components/folder-settings-dialog';

const getCaptions = () => ({
  title: i18next.t('Folder settings'),
  folderNameLabel: i18next.t('Folder name'),
  submit: i18next.t('Submit'),
  cancel: i18next.t('Cancel'),
});

function FolderSettingsDialogContainer({
  folderId,
  folderName,
  onDialogMainAction,
  onDialogCancel,
}) {
  const dispatch = useDispatch();
  const folders = useSelector(site.selectors.getFolders);

  const captions = getCaptions();

  const handleCancel = () => {
    onDialogCancel({
      folderName,
    });
    dispatch(dialogs.actions.show(dialogTypes.PAGE_MANAGER));
  };

  const handleSubmit = (newFolderName) => {
    onDialogMainAction({
      folderName: newFolderName,
    });
    const currentFolder = folders.find((folder) => folder.id === folderId);
    const isSameName = currentFolder.name === newFolderName;

    if (!isSameName) {
      dispatch(site.actions.renameFolder(folderId, newFolderName));
      saveSite();
    }

    dispatch(dialogs.actions.show(dialogTypes.PAGE_MANAGER));
  };

  return (
    <FolderSettingsDialog
      defaultFolderName={folderName}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      captions={captions}
    />
  );
}

FolderSettingsDialogContainer.propTypes = {
  folderId: PropTypes.string.isRequired,
  folderName: PropTypes.string.isRequired,
  onDialogMainAction: PropTypes.func.isRequired,
  onDialogCancel: PropTypes.func.isRequired,
};

export default FolderSettingsDialogContainer;
